import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DynamicCssService {

  loadStyle(href: string) {
    const head = document.getElementsByTagName('head')[0];
    const styles = Array.from(head.getElementsByTagName('link')).map(l => l.href);

    if (!styles.some(style => style.includes(href))) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = href + `?v=${environment.styleVersion}`;
      head.appendChild(link);
    }
  }

  removeStyle(href: string) {
    const head = document.getElementsByTagName('head')[0];
    const links = Array.from(head.getElementsByTagName('link'));

    for (const link of links) {
      if (link.href.includes(href)) {
        head.removeChild(link);
      }
    }
  }
}
